import type { ReactNode } from "react";
import { ToastViewport } from "@/components/ui/toast";

export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <ToastViewport />
    </>
  );
}
